import { defineMessages } from 'react-intl';

export const headMetaMessages = defineMessages({
  review: {
    id: 'reviewsPage.review',
    defaultMessage: '{brandName} {collection} reviews',
  },
  seoTitle: {
    id: 'reviews.seo.title',
    defaultMessage: '{productName} recenze | notino.cz',
  },
  seoKeywords: {
    id: 'reviews.seo.keywords',
    defaultMessage: '{productName} recenze, {productShortName} recenze',
  },
  seoUrl: {
    id: 'reviews.seo.url',
    defaultMessage: '/recenze{productUrl}',
  },
});
